export function isPolySquare(s) {
    return 'poly' in s;
}
export function isRectSquare(s) {
    return 'nw' in s && 'se' in s;
}
//# sourceMappingURL=types.js.map